import { render } from "./YourDetailsBanner.vue?vue&type=template&id=cb06a272&scoped=true"
import script from "./YourDetailsBanner.vue?vue&type=script&lang=js"
export * from "./YourDetailsBanner.vue?vue&type=script&lang=js"

import "./YourDetailsBanner.vue?vue&type=style&index=0&id=cb06a272&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1732206420/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb06a272"]])

export default __exports__